<!--
 * @Author: 张天昊
 * @Date: 2024-05-30 16:37:28
 * @LastEditTime: 2024-06-04 14:31:10
 * @LastEditors: 张天昊
 * @Description: 游客表格姓名单元格
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/TouristNameTableCell.vue
-->
<script>
import { defineComponent } from 'vue';
import { TouristAgeTypes } from '../constants';
import { transformEnumValue2Label } from '../utils';
import bg from '@/assets/itineraryUniversal/bg-left-group.png';

export default defineComponent({
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    return {
      bg,
      TouristAgeTypesValue2Label: transformEnumValue2Label(TouristAgeTypes),
      TouristAgeTypes
    };
  }
});
</script>

<template>
  <div>
    <div class="relative z-1 font-14 leading-20 text-black-a content">{{ data.name }}</div>
    <div class="relative z-1 mt-2 text-12 leading-17 content">
      <van-tag class="custom-tag" color="#EDEDED" textColor="#666">{{
        data.sexCode ? '女' : '男'
      }}</van-tag>
      <van-tag
        v-if="data.ageType === TouristAgeTypes.老人"
        class="ml-2 custom-tag"
        color="#FAB46E"
        >{{ TouristAgeTypesValue2Label[data.ageType] }}</van-tag
      >
      <span v-else class="ml-4 text-grey-g">{{
        TouristAgeTypesValue2Label[data.ageType]
      }}</span>
    </div>
    <img v-if="!!data.disabled" :src="bg" class="absolute -z-1 w-43 h-43 top-0 right-0" />
  </div>
</template>

<style scoped>
.custom-tag.van-tag {
  line-height: 17px;
}
</style>
